
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vogel-actu/livv-newsflash",
      function () {
        return require("private-next-pages/vogel-actu/livv-newsflash.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vogel-actu/livv-newsflash"])
      });
    }
  